<div>
    <form [formGroup]="validationForm">
        <div class="field" *ngIf="customField.custom_field_type_id === customFields.RadioButton">
            <label class="font-medium text-900">{{ customField.label }}</label>
            <span *ngIf="customField.usage[0].is_required === true" class="asterisk">*</span>
            <div class="field">
                <div class="formgrid grid radio-group">
                    <div class="col-12">
                        <div class="radio-buttons-container">
                            <div class="formgrid grid" *ngFor="let row of listData">
                                <div class="col-12 md:col-4">
                                    <div class="field-radiobutton">
                                        <p-radioButton formControlName="customFieldList" [value]="row.value"
                                            id="radio_id_{{row.value}}" (ngModelChange)="changeEvent($event)"
                                            (blur)="onValidationStatusChange()" [(ngModel)]="textVal" 
                                            [ngClass]="{
                                                'is-invalid': validationForm.get('customFieldList')?.invalid && (validationForm.get('customFieldList')?.dirty || validationForm.get('customFieldList')?.touched || submit)
                                                }">
                                        </p-radioButton>
                                        <label for="radio_id_{{row.value}}">{{ row.value }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span *ngIf="customField?.instructions">
                <small>{{ customField.instructions }}</small>
            </span><br>
            <span *ngIf="validationForm.get('customFieldList')?.invalid && (validationForm.get('customFieldList')?.dirty || validationForm.get('customFieldList')?.touched || submit)">
                <small class="alert-danger" *ngIf="validationForm.get('customFieldList')?.errors?.['required']">{{translation_service.getText('message_25')}}</small>
            </span>
        </div>
    </form>
</div>